<template>
  <FinderCard data-test="finder-requirements-card" :title="criterion.title">
    <div class="relative flex flex-1 flex-col gap-16">
      <div
        class="flex w-full flex-wrap gap-8 grow"
        data-test="finder-requirements-chips"
      >
        <FinderFacetChip
          v-for="facet in displayedFacets"
          :key="facet.name"
          :data-test="`finder-requirements-chip-${facet.name}`"
          :facet
          :selected-values="filters[facet.name] ?? []"
        />
      </div>

      <div class="mt-auto flex w-full items-center">
        <RevChip
          data-test="finder-requirements-more-filters"
          :label="criterion.moreFiltersLabel"
          size="medium"
          :start-icon="IconEqualizerSmall"
          @click.stop="openFullDrawer"
        />
      </div>
    </div>
  </FinderCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Facet } from '@backmarket/nuxt-layer-recommendation/filtering/types'
import { useFullscreenFilters } from '@backmarket/nuxt-layer-recommendation/filtering/useFullscreenFilters'
import { RevChip } from '@ds/components/Chip'
import { IconEqualizerSmall } from '@ds/icons/IconEqualizerSmall'

import type { FinderRequirementsCriterion } from '../../../../composables/useFinder/useFinder.types'
import FinderCard from '../FinderCard/FinderCard.vue'
import FinderFacetChip from '../FinderFacetChip/FinderFacetChip.vue'

const MAX_DISPLAYED_FACETS = 4

const props = defineProps<{
  criterion: FinderRequirementsCriterion
  facets: Facet[]
}>()

const filters = defineModel<Record<string, string[]>>('filters', {
  required: true,
})
const { filter: openFullscreenFilter } = useFullscreenFilters()

const displayedFacets = computed(() =>
  props.facets.slice(0, MAX_DISPLAYED_FACETS),
)

function openFullDrawer(event: MouseEvent): void {
  openFullscreenFilter(event as PointerEvent)
}
</script>
